import { executeFunctionAfterHandler } from "@1js/acui-common";

export function getPropsWithMenuDismiss<
  T extends
    | { onExecute?: (...args: any[]) => void }
    // This is needed to make the TS compiler happy
    | {},
>(props: T, dismissMenu: () => void): T {
  const rawProps = props as any;

  // Override the role if a roleInMenu is defined
  const updatedProps = {
    ...rawProps,
    role: rawProps.roleInMenu ?? rawProps.role ?? "menuitem",
  };
  if (
    "dismissHostingSurfaceOnExecute" in props &&
    props.dismissHostingSurfaceOnExecute === false
  ) {
    return updatedProps;
  }

  return {
    ...updatedProps,
    onExecute: executeFunctionAfterHandler(rawProps.onExecute, dismissMenu),
  };
}
